import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSwapmin = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.904 10.406H2.672a.141.141 0 0 0-.14.14v1.056c0 .077.062.14.14.14H13.31l-2.537 3.217a.141.141 0 0 0 .111.229h1.275a.282.282 0 0 0 .221-.108l2.967-3.763a.563.563 0 0 0-.443-.91Zm.424-4.148H4.69L7.226 3.04a.142.142 0 0 0-.11-.228H5.84a.282.282 0 0 0-.221.107L2.652 6.683c-.29.37-.028.91.442.91h12.234a.14.14 0 0 0 .14-.14V6.398a.141.141 0 0 0-.14-.14Z",
		fill: "#8C8C8C"
	})
});
const ForwardRef = forwardRef(SvgSwapmin);
export { ForwardRef as ReactComponent };
